import { Button, styled, themeGet } from '@qwealth/qcore';

export const UpdateButton = styled(Button)`
  align-self: flex-end;
  margin-top: -20px;
  margin-bottom: ${themeGet('space.large')};
`;
